import { render, staticRenderFns } from "./PortfolioSection.vue?vue&type=template&id=0871c207&"
import script from "./PortfolioSection.vue?vue&type=script&lang=js&"
export * from "./PortfolioSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports